<template>
  <div class="user-center-issue-order">
    <nav>
      <span
        @click="
          form.status = '待处理';
          form.page = 1;
          $forceUpdate();
          getData(form);
        "
        :class="form.status == '待处理' ? 'active' : ''"
        ><span class="label">{{ $fanyi("等待处理") }}</span
        ><span class="numberCount">({{ tableTypeNum[0].num }})</span></span
      ><span
        @click="
          form.status = '处理中';
          form.page = 1;
          $forceUpdate();
          getData();
        "
        :class="form.status == '处理中' ? 'active' : ''"
        ><span class="label">{{ $fanyi("处理中") }}</span
        ><span class="numberCount">({{ tableTypeNum[1].num }})</span></span
      >
      <span
        @click="
          form.status = '已处理';
          form.page = 1;
          $forceUpdate();
          getData();
        "
        :class="form.status == '已处理' ? 'active' : ''"
        ><span class="label">{{ $fanyi("历史问题") }}</span
        ><span class="numberCount">({{ tableTypeNum[2].num }})</span></span
      >
      <span class="flexBox"></span>
    </nav>
    <div>
      <div class="searchBox">
        <div class="myInput">
          <i class="el-icon-search"></i>
          <input
            type="text"
            v-model="form.searchText"
            @keydown.enter="getData()"
            :placeholder="$fanyi('请输入关键词搜索')"
          />
        </div>
        <el-button
          class="searchBtn "
          @click="
            form.page = 1;
            getData(form);
          "
        >
          {{ $fanyi("搜索") }}
        </el-button>
      </div>
      <!-- 表格 -->
      <div class="dataBody">
        <el-table
          :data="tableData"
          style="width: 100%"
          :header-cell-style="{
            'text-align': 'center',
            background: '#f4f4f4',
            color: 'black',
            'font-size': '12px',
            'font-weight': '500',
          }"
          :cell-style="{ 'text-align': 'center' }"
        >
          <el-table-column type="index" width="50" label="Nº">
          </el-table-column>

          <el-table-column prop="date" :label="$fanyi('订单号')" width="320">
            <template slot-scope="scope">
              <button
                class="order_sn"
                @click="
                  $fun.routerToPage(
                    '/issueOrderDetail?order_sn=' +
                      scope.row.order_sn +
                      '&status=' +
                      $fun.toCode(form.status) //后端问题产品详情接口只设置了接收 待处理/处理中/已处理 其他状态也传这三个
                  )
                "
              >
                {{ scope.row.order_sn }}
              </button>
            </template>
          </el-table-column>
          <el-table-column prop="name" :label="$fanyi('联系负责人')">
            <template slot-scope="scope">
              <img
                class="lianxiren"
                src="../../../../assets/user-img/contacts.svg"
                alt=""
                @click="tocaht"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="problem_goods_created_at"
            :label="$fanyi('问题提出日期')"
          >
          </el-table-column>
          <el-table-column prop="count" :label="$fanyi('问题条数')">
          </el-table-column>
          <el-table-column prop="sum" :label="$fanyi('问题商品数量')">
          </el-table-column>
        </el-table>
        <div class="allpag">
          <span></span>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="form.currentPage"
            :page-size="10"
            :page-sizes="[10, 20, 30, 50]"
            layout=" prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <sideBar v-show="false" ref="sideBar"></sideBar>
  </div>
</template>

<script>
import sideBar from "../../../../components/homePage/sideBar.vue";
export default {
  data() {
    return {
      form: {
        status: "待处理",
        page: 1,
        pageSize: 10,
        searchText: "",
      },
      tableData: [],
      total: 0,
      tableTypeNum: [
        {
          table: "待处理", //名称
          num: 0, //数量
        },
        {
          table: "处理中", //名称
          num: 0, //数量
        },
        {
          table: "已处理", //名称
          num: 0, //数量
        },
      ],
    };
  },
  components: { sideBar },
  computed: {},
  created() {
    this.getData();
    this.getTitleNumber();
  },
  methods: {
    // 打开聊天窗口
    tocaht() {
      this.$refsthis.$fun.clickJs();
    },
    // 获取种类数量数据
    getTitleNumber() {
      this.$api.problemGoodsOrderNum().then((res) => {
        //console.log("problemGoodsOrderNum", res);
        if (res.code != 0) return;
        if (res.data.length == 0) return false;
        this.tableTypeNum = res.data;
      });
    },
    // 获取数据
    getData() {
      let datas = {
        status: this.form.status,
        pageSize: this.form.pageSize,
        page: this.form.page,
        keywords: this.form.searchText,
      };
      this.$api.problemGoodsOrderList(datas).then((res) => {
        //console.log("problemGoodsOrderList", res);
        if (res.code != 0) return;
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    handleSizeChange(val) {
      this.form.pageSize = val;
      this.form.pageSize = 1;
      this.getData(this.form);
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.getData(this.form);
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
.user-center-issue-order {
  @import "../../../../css/mixin";
  width: 1060px;

  button {
    cursor: pointer;
  }
  > nav {
    display: flex;
    border: 1px solid #eaecf0;
    border-bottom: none;
    background-color: #fff;
    border-radius: 12px 12px 0 0;
    overflow: hidden;

    > span {
      @extend .dip;
      width: max-content;
      min-width: 100px;
      flex-direction: column;
      height: 48px;
      padding: 0 13px;
      background: #f9f9f9;
      font-size: 12px;
      line-height: 16px;
      text-align: center;
      color: #000000;
      line-height: 16px;
      cursor: pointer;
      position: relative;
      border-bottom: 1px solid #eaecf0;
      border-right: 1px solid #eaecf0;

      &.active {
        background-color: #ffffff;
        border-bottom: none;
      }
      &.active::after {
        background: #ffffff;
      }
      .label {
        line-height: 16px;
        width: 100%;
        white-space: nowrap;
        display: block;
        text-align: left;
      }
      span.wrapTitle {
        white-space: normal;
        line-height: 1.1;
      }

      .numberCount {
        width: 100%;
        font-weight: 500;
        font-size: 12px;
        line-height: 18px;
        text-align: left;
        color: #009246;
      }
    }
    .flexBox {
      flex: 1;
      background-color: #fff;
    }
    > span.allStatusSpan {
      flex: 0 0 60px;
    }
    .yellowIconBox {
      flex: 0 0 40px;
      background-color: #fff;
      border-bottom: 1px solid #eaecf0;
      .yellowIcon {
        @extend .dip;
        width: 50px;
        cursor: pointer;
        .yellowIconImg {
          width: 20px;
          height: 20px;
          display: block;
        }
      }
    }
  }

  > div {
    // min-height: 720px;
    background: #ffffff;
    border: 1px solid #e1e1e1;
    border-top: none;
    padding: 20px 20px 37px 20px;
    .searchBox {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 20px;
      gap: 12px;
      .myInput {
        width: 360px;
        height: 40px;
        position: relative;
        display: flex;
        align-items: center;
        overflow: hidden;

        > i {
          width: 20px;
          height: 24px;
          margin: 9px 11px 9px 12px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
        }

        > input {
          border: none;
          border-radius: 8px;
          border: 0.5px solid #d0d5dd;
          width: 100%;
          height: 100%;
          font-size: 14px;
          padding-left: 40px;
          padding-right: 10px;
          transition: 0.3s;
          &::placeholder {
            color: #d0d5dd;
          }

          &:focus {
            border-color: #009246;
          }
        }
      }

      /deep/.el-date-editor {
        height: 40px;
        .el-range-input {
          font-size: 14px;
        }

        .el-range-separator {
          width: 50px;
        }
      }
      .searchBtn {
        width: 90px;
        height: 40px;
        background: $homePageSubjectColor;
        border-radius: 8px;

        color: #ffffff;
        font-size: 16px;
      }
    }

    .dataBody {
      border: 1px solid #eaecf0;
      border-radius: 12px;
      overflow: hidden;

      /deep/thead {
        .el-table__cell {
          width: 50px;
          height: 48px;
          background: #f4f4f4;
          padding: 5px 0;
          .cell {
            font-weight: 400;
            word-break: keep-all;
            font-size: 12px;
            line-height: 1.3;
            color: #000000;
          }
        }
      }

      .order_sn {
        font-size: 14px;
        color: #009246;
        line-height: 20px;
        background-color: transparent;
      }
      .lianxiren {
        width: 32px;
        height: 32px;
        cursor: pointer;
      }
    }
    .allpag {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 25px 0;

      > a {
        display: inline-block;
        border: 1px solid #dfe8df;
        height: 28px;
        background-color: white;
        text-align: center;
        padding: 0 10px;
        font-size: 13px;
        line-height: 28px;
        border-radius: 2px;
      }

      /* 分页被选中的页码样式 */
      /deep/ .el-pager li {
        margin: 0 3px;
        border-radius: 4px;
        box-shadow: 0px 0px 6px 0px rgba(61, 61, 61, 0.1);

        &:hover {
          color: $homePageSubjectColor;
        }

        &.active {
          background-color: $homePageSubjectColor;
          color: white;
        }
      }
    }
  }
}
</style>
